import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { format } from 'date-fns';
import { SimplifiedDataResponse } from '../../../services/ph3aService';

interface DataResultDisplayProps {
  data: SimplifiedDataResponse;
}

const DataResultDisplay: React.FC<DataResultDisplayProps> = ({ data }) => {
  const { Data } = data;
  if (!Data) {
    return <div className="alert alert-warning mt-3">Dados não encontrados na resposta.</div>;
  }

  const formatGender = (genderCode: string) => {
    if (genderCode === '1' || genderCode.toLowerCase() === 'masculino') return 'Masculino';
    if (genderCode === '2' || genderCode.toLowerCase() === 'feminino') return 'Feminino';
    return genderCode;
  };

  const formatBirthDate = (isoDate: string) => {
    try {
      if (isoDate.includes('T')) {
          return format(new Date(isoDate), 'dd/MM/yyyy');
      }
      return isoDate;
    } catch {
      return 'Data inválida';
    }
  };

  const formatAddresses = (addresses: typeof Data.Addresses) => {
    if (!addresses || addresses.length === 0) return 'Nenhum endereço encontrado';

    const formattedList = addresses.map(addr => {
      // Se existir o alias, apenas ele será usado
      if (addr.Alias) {
        return addr.Alias;
      }
      // Senão, será criada uma string com os outros dados, ignorando campos nulos
      const parts = [addr.District, addr.City, addr.State, addr.ZipCode].filter(Boolean);
      return parts.join(', ');
    });

    return formattedList.join(';<br />');
  };
  
  const formatSimpleList = (items: any[], key: string, quote: boolean = false) => {
    if (!items || items.length === 0) return `Nenhum ${key.toLowerCase()} encontrado`;
    
    const formattedList = items.map(item => quote ? `"${item[key]}"` : item[key]);
    
    return formattedList.join(';<br />');
  };

  return (
    <div className="mt-4">
      <h5 className="mb-3">Dossiê do Documento: {Data.DocumentFormatted} | RequestId: {data.RequestId}</h5>
      <table className="table table-bordered table-striped">
        <tbody>
          <tr>
            <td className="table-light" style={{ width: '25%' }}><strong>Nome</strong></td>
            <td>{Data.Name}</td>
          </tr>
          <tr>
            <td className="table-light"><strong>Gênero</strong></td>
            <td>{formatGender(Data.Gender)}</td>
          </tr>
          <tr>
            <td className="table-light"><strong>Data de Nascimento</strong></td>
            <td>{formatBirthDate(Data.BirthDate)}</td>
          </tr>
          <tr>
            <td className="table-light"><strong>Endereços</strong></td>
            {/* usando o dangerouslySetInnerHTML para renderizar as quebras de linha */}
            <td dangerouslySetInnerHTML={{ __html: formatAddresses(Data.Addresses) }} />
          </tr>
          <tr>
            <td className="table-light"><strong>Emails</strong></td>
            <td dangerouslySetInnerHTML={{ __html: formatSimpleList(Data.Emails, 'Email', true) }} />
          </tr>
          <tr>
            <td className="table-light"><strong>Telefones</strong></td>
            <td dangerouslySetInnerHTML={{ __html: formatSimpleList(Data.Phones, 'FormattedNumber') }} />
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default DataResultDisplay;